import { useTranslation } from "@refinedev/core";

import { InputLabel, Stack, TextField, Typography } from "@mui/material";

export interface MedicationInfoInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const MedicationInfoInput = ({ value, onChange, error }: MedicationInfoInputProps) => {
  const { translate } = useTranslation();

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap" pl={3.5}>
      <InputLabel required>{translate("pages.patientOverview.conditionParameters.medicationInfoLabel")}</InputLabel>
      <Typography variant="body2">
        : {translate("pages.patientOverview.conditionParameters.medicationInfoPrefix")}
      </Typography>
      <TextField
        size="small"
        required
        placeholder={translate("pages.patientOverview.conditionParameters.medicationInfoPlaceholder")}
        value={value}
        onChange={e => onChange(e.target.value)}
        error={!!error}
        helperText={error}
      />
      <Typography variant="body2">.</Typography>
    </Stack>
  );
};
